import { render, staticRenderFns } from "./ProjectItemMove.vue?vue&type=template&id=1e31111b&scoped=true&"
import script from "./ProjectItemMove.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemMove.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemMove.vue?vue&type=style&index=0&id=1e31111b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31111b",
  null
  
)

export default component.exports